import axios from "axios";
import { clearLocalStorage, getAccessToken } from "../../constants/utils";
import { BE_URL } from "../../common/url";

const instance = axios.create({
  baseURL: BE_URL,
});

export const axiosGet = async ({ path }) => {
  const res = await instance.get(path);
  return res;
};

export const axiosPost = async ({ path, payload }) => {
  const res = await instance.post(path, payload);
  return res;
};

export const axiosPatch = async ({ path, payload }) => {
  const res = await instance.patch(path, payload);
  return res;
};

export const axiosPut = async({path,payload})=>{
  const res = await instance.put(path,payload);
  return res;
}

export const axiosDelete = async ({ path }) => {
  const res = await instance.delete(path);
  return res;
};

export const axiosGetManualToken = async ({ path, token }) => {
  const res = await instance.get(path, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

instance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (
      error.response &&
      [401].includes(error.response.data.statusCode)
    ) {
      clearLocalStorage();
      if (typeof window !== "undefined") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
